module.exports = __webpack_public_path__ + "static/media/oxford_light.76c8fd90.png";